import React, { useEffect, useRef, useState } from "react";

export default function FileViewer({
  fileUrl,
  height = 300,
  maxWidth = 800,
  className,
  style,
  // Note: renderAllPages is not applicable with the native <embed> solution
}) {
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef(null);

  const isPDF = typeof fileUrl === "string" && fileUrl.toLowerCase().endsWith(".pdf");
  const isImage = typeof fileUrl === "string" && /\.(jpe?g|png|gif|webp|svg)$/i.test(fileUrl);

  // Track container width for responsive Page width
  useEffect(() => {
    if (!containerRef.current) return;
    const ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        const w = entry.contentRect?.width || containerRef.current.clientWidth;
        setContainerWidth(w);
      }
    });
    ro.observe(containerRef.current);
    setContainerWidth(containerRef.current.clientWidth);
    return () => ro.disconnect();
  }, []);

  if (!fileUrl) return <div className={`p-4 bg-gray-100 border border-gray-300 rounded-lg ${className}`} style={style}>No file provided.</div>;

  // Common container that enforces a max/fixed height + scroll
  const containerStyles = {
    position: "relative",
    maxHeight: `${height}px`,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "8px",
    background: "#fafafa",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    ...style,
  };

  if (isPDF) {
    return (
      // <div 
      //   ref={containerRef} 
      //   className={`${className} mx-auto flex items-center justify-center`} 
      //   style={{ ...containerStyles, maxWidth: `min(100%, ${maxWidth}px, fit-content)` }}
      // >
        <iframe
          src={fileUrl}
          type="application/pdf"
          className="w-full h-full"
          style={{ minHeight: `${height - 16}px` }}
        />
      // </div>
    );
  }

  if (isImage) {
    return (
      <div 
        ref={containerRef} 
        className={`${className} mx-auto flex items-center justify-center`} 
        style={{ ...containerStyles, maxWidth: `min(100%, ${maxWidth}px, fit-content)` }}
      >
        <img
          src={fileUrl}
          alt="preview"
          className="max-w-full max-h-full object-contain"
        />
      </div>
    );
  }

  return (
    <div ref={containerRef} className={className} style={containerStyles}>
      Unsupported file type.
    </div>
  );
}
